import convertImageToBase64 from '../../utils/converitr-imagen-base64';
import { apiFetch } from '../../utils/api';

export const formularioTopSlice = (set,get) => ({
    obtenerTop: async () => {
        try {
            const [topResponse, productsResponse, branchesResponse] = await Promise.all([
                apiFetch("/api/top"),
                apiFetch("/api/products"),
                apiFetch("/api/branches"),
            ]);
            if(topResponse.status){
                const tops = Array.isArray(topResponse.data) ? topResponse.data : [];
                const productos = Array.isArray(productsResponse.data) ? productsResponse.data : [];
                const sucursales = Array.isArray(branchesResponse.data) ? branchesResponse.data : [];

                set({ productos: productos.map((item) => { return { value: item.id, label: item.nombre } }) })

                let imagenesProductos = []
                for(let i = 0; i < tops.length; i++){
                    const top = tops[i];
                    const items = Array.isArray(top.items) ? top.items : [];

                    for(let j = 0; j < items.length; j++){
                        const item = items[j];
                        const imagen = item.imagen || "";
                        let preview = imagen;
                        try {
                            preview = imagen ? await convertImageToBase64(imagen) : "";
                        } catch (e) {
                            console.error("Error al cargar la imagen del top:", e);
                            preview = imagen || "existente";
                        }

                        imagenesProductos.push({
                            id:`${top.id}-${j}`,
                            nombre:imagen.split('/').pop() || `top-${j + 1}`,
                            file:null,
                            esNuevo:false,
                            preview,
                            imagen,
                            titulo:item.titulo || "",
                            categoria:item.productId || item.dishId || item.categoryId || "",
                            sucursal:top.branchId || "",
                        })
                    }
                }

                set({multiImagenes:imagenesProductos, multiImagenesTemp:imagenesProductos});
                set({ sucursalSelecionada: sucursales[0] ? [{ value: sucursales[0].id, label: sucursales[0].nombre }] : [] })
                set({ sucursales: sucursales.map((item) => { return { value: item.id, label: item.nombre } }) })
            } else {
                window.notie?.alert({ type: 'warning', text: topResponse.message || 'No se pudo cargar el top' });
            }
           set({isLoading:false});
        } catch (error) {
            console.error('Error al cargar top:', error);
            window.notie?.alert({ type: 'error', text: error.message || 'Error al cargar top' });
            set({isLoading:false});
        }
    },
    handleSave: async () => {
        const sucursalId = get().sucursalSelecionada[0]?.value;
        if(!sucursalId){
            window.notie?.alert({ type: 'error', text: 'Selecciona una sucursal para guardar el top.' });
            return;
        }

        const formData = new FormData();
        let datosImagnes = []
        for(let i = 0; i < get().multiImagenesTemp.length; i++){
            let dato = get().multiImagenesTemp[i];
            if(dato.sucursal === sucursalId){
               if(dato.esNuevo){
                    formData.append('imagenes', dato.file);
                }
                datosImagnes.push({
                    productId: dato.categoria,
                    dishId: dato.categoria,
                    categoryId: dato.categoria,
                    titulo: dato.titulo,
                    imagen: dato.esNuevo ? undefined : dato.imagen,
                }) 
            }
        }
        formData.append('datos', JSON.stringify({
            branchId: sucursalId,
            items: datosImagnes,
        }));
        try {
            const data = await apiFetch("/api/top",{
                method: "POST",
                body: formData
            });
            console.log(data);
            if(data.status){
                window.notie?.alert({ type: 'success', text: 'Top registrado correctamente' });
                await get().obtenerTop();
            } else {
                window.notie?.alert({ type: 'warning', text: data.message || 'No se pudo guardar el top' });
            }
        } catch (error) {
            console.error('Error al guardar top:', error);
            window.notie?.alert({ type: 'error', text: error.message || 'Error al guardar top' });
        }
      },
})
